"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnquiryFormFieldIDs_1 = require("../enum/EnquiryFormFieldIDs");
var enquiryFormInputFieldErrorMessage = {
    setErrorMessage: function (formData, rawErrors) {
        var _a, _b;
        if (formData.id === EnquiryFormFieldIDs_1.EnquiryFormFieldIDs.IDENTIFICATION_NUMBER_OF_DOCUMENT_TYPE) {
            var errMessageHint_1 = (_a = formData.schema) === null || _a === void 0 ? void 0 : _a.maxLength;
            return (_b = rawErrors) === null || _b === void 0 ? void 0 : _b.find(function (err) {
                var message = err;
                return message.search(errMessageHint_1.toString()) !== -1;
            });
        }
    },
};
exports.default = enquiryFormInputFieldErrorMessage;
